import { useEffect, useState } from 'react';
const MOBILE_BREAKPOINT = 768;
const TABLET_BREAKPOINT = 1024;
const VIEWPORT_ALWAYS = '0';
const VIEWPORT_MOBILE = '1';
const VIEWPORT_TABLET = '2';
const VIEWPORT_DESKTOP = '3';
function pickByWidth(images, width) {
    if (width <= MOBILE_BREAKPOINT)
        return images[VIEWPORT_MOBILE] || null;
    if (width <= TABLET_BREAKPOINT)
        return images[VIEWPORT_TABLET] || null;
    return images[VIEWPORT_DESKTOP] || null;
}
export function useViewportImage(images) {
    const getInitial = () => {
        if (!images)
            return null;
        if (images[VIEWPORT_ALWAYS])
            return images[VIEWPORT_ALWAYS];
        if (typeof window === 'undefined')
            return null;
        return pickByWidth(images, window.innerWidth);
    };
    const [url, setUrl] = useState(getInitial);
    useEffect(() => {
        if (!images) {
            setUrl(null);
            return;
        }
        if (images[VIEWPORT_ALWAYS]) {
            setUrl(images[VIEWPORT_ALWAYS]);
            return;
        }
        if (typeof window === 'undefined')
            return;
        const mqlMobile = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`);
        const mqlTablet = window.matchMedia(`(max-width: ${TABLET_BREAKPOINT}px)`);
        const recompute = () => {
            setUrl(pickByWidth(images, window.innerWidth));
        };
        recompute();
        mqlMobile.addEventListener('change', recompute);
        mqlTablet.addEventListener('change', recompute);
        return () => {
            mqlMobile.removeEventListener('change', recompute);
            mqlTablet.removeEventListener('change', recompute);
        };
    }, [images]);
    return url;
}
